<template>
  <div class="col-6 col-md-3 col-xl-2 flex-column" :class="index > 4 ? 'd-none d-xl-flex' : index > 2 ? 'd-none d-md-flex' : 'd-flex'">
    <a :href="`/studio-detail/?id=${studioInfo.studio_id}`">
      <div class="thumbnail" :style="`background:url(${thumbnailUrl})no-repeat center / cover;`"></div>
      <div class="smallStudioContents d-flex align-items-start flex-column">
        <ListIcons :flags="flags" classes="d-flex justify-content-between" />
        <p class="studioName">{{ studioInfo.studio_name }}</p>
        <p class="studioAddress">{{ studioInfo.prefecture }}</p>
      </div>
    </a>
  </div>
</template>
<script>
import ListIcons from "../../../components/ListIcons.vue";
export default {
  name: "AreaList",
  components: {
    ListIcons,
  },
  props: {
    studioInfoData: {
      type: String,
      require: true,
    },
    thumbnailUrl: {
      type: String,
      require: true,
    },
    flagsData: {
      type: String,
      require: true,
    },
    index: {
      type: String,
      require: true,
    },
  },
  computed: {
    studioInfo() {
      return JSON.parse(this.studioInfoData);
    },
    flags() {
      return JSON.parse(this.flagsData);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.thumbnail {
  aspect-ratio: 16 / 9;
}
</style>
